import { useMemo } from 'react'
import { useState } from 'react'
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../../components/hooks';
import { TableCustom, FormLabel, Modal, FormError } from '../../../components/common'
import { OPERATION_MODE } from '@laramie/ui';
import {TIPS} from "../../../consts/tips";

const TablaColumnas = ({columnas, setColumnas, params, setPendingChange, disabled}) => {
    const [edittingColumna, setEdittingColumna] = useState()
    const [mode, setMode] = useState()
    const data = useMemo(() => columnas, [columnas])

    const getErrors = () => {
        const errors = {}
        if (!edittingColumna) return errors

        if (edittingColumna.nombre.length <= 0) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (edittingColumna.descripcion.length <= 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED

        return errors
    }

    const { errorOf, validate, reset } = useFormErrors(getErrors)

    const onAdd = () => {
        reset()
        setMode('add')
        setEdittingColumna({
            id: -Date.now(),
            nombre: '',
            descripcion: ''
        })
    }

    const onModify = (columna) => {
        reset()
        setMode('modify')
        setEdittingColumna(columna)
    }

    const onRemove = (columna) => {
        setColumnas(columnas.filter(x => x.id !== columna.id))
        setPendingChange(true)
    }

    const onClickModalAccept = () => {
        if (!validate()) return

        if (mode === 'add') {
            setColumnas([...columnas, edittingColumna])
        }

        else if (mode === 'modify') {
            setColumnas(columnas.map(x => x.id === edittingColumna.id ? {...edittingColumna,} : x))
        }

        setMode(null)
        setPendingChange(true)
    }

    const onClickModalCancel = () => {
        reset()
        setMode(null)
        setEdittingColumna(null)
    }

    const cellA = (data) =>  <div className='action'>
        {params.mode !== OPERATION_MODE.VIEW && columnas?.length < 10 && (
        <div onClick={ (event) => onAdd() } className="link">
            <span className="material-symbols-outlined" title="Nuevo">add</span>
        </div>
        )}
    </div>
    const cellVMR = (data) =>  <div className='action'>
        {params.mode !== OPERATION_MODE.VIEW && (
        <>
        <div onClick={ (event) => onModify(data.row.original) } className="link">
            <span className="material-symbols-outlined" title="Modificar">stylus</span>
        </div>
        <div onClick={ (event) => onRemove(data.row.original) } className="link">
            <span className="material-symbols-outlined" title="Eliminar">delete</span>
        </div>
        </>
        )}
    </div>

    const tableColumns = disabled ? [
        { Header: 'Nombre', accessor: 'nombre', width: '45%' },
        { Header: 'Descripción', accessor: 'descripcion', width: '55%' }
    ] : [
        { Header: 'Nombre', accessor: 'nombre', width: '45%' },
        { Header: 'Descripción', accessor: 'descripcion', width: '50%' },
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
    ]

    return (
        <div>
            <div className="col-12">
                <label className="form-label">Columnas</label>
                <TableCustom
                    showFilterGlobal={false}
                    showDownloadCSV={false}
                    className='TableCustomBase'
                    columns={tableColumns}
                    data={data}
                />
            </div>
     
            {!!mode && (
                <Modal
                    size="lg"
                    title="Columna"
                    tipName={TIPS.NAME.MODALS.COLUMNAS_MODAL}
                    onEscape={onClickModalCancel}
                    body={(
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                                        <input
                                            name="nombre"
                                            type="text"
                                            placeholder=""
                                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                                            value={edittingColumna.nombre}
                                            onChange={({ target }) => setEdittingColumna(prev => ({...prev, nombre: target.value}))}
                                            maxLength={50}
                                        />
                                        <FormError message={errorOf('nombre')} />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                                        <input
                                            name="descripcion"
                                            type="text"
                                            placeholder=""
                                            className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                            value={edittingColumna.descripcion}
                                            onChange={({ target }) => setEdittingColumna(prev => ({...prev, descripcion: target.value}))}
                                            maxLength={50}
                                        />
                                        <FormError message={errorOf('descripcion')} />
                                    </div>
                                </div>
                    )}
                    footer={(<>
                            {mode !== 'view' && (
                                <>
                                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onClickModalCancel}>Cancelar</button>
                                <button className="btn btn-primary" data-dismiss="modal" onClick={onClickModalAccept}>Aceptar</button>
                                </>
                                )}
                                {mode == 'view' && (
                                    <div className="width-100p f-align">
                                        <button className="btn back-button" data-dismiss="modal" onClick={onClickModalCancel}>Volver</button>
                                    </div>
                                )}
                    </>)}
                />
            )}
        </div>
    )
}

export default TablaColumnas
